import environment from "@menu-environment";

const imageUrl = (filename: string) => environment.menu.urls.assets + filename;

export default imageUrl;